import React from 'react';

function ToggleIcon({ checked = false }) {
  // Note: the active style for this component is managed through the css.
  return (
    <svg className={`toggle-icon ${checked ? 'toggle-icon--checked' : ''}`} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 42 24" enableBackground="new 0 0 42 24">
      <path fill="#D8D8D8" stroke="#D8D8D8" strokeWidth="0.5" d="M40.3,12c0-5.7-4.6-10.3-10.3-10.3H12 C6.3,1.7,1.7,6.3,1.7,12c0,5.7,4.6,10.3,10.3,10.3h18C35.7,22.3,40.3,17.7,40.3,12z" />
      <ellipse fill="#FFFFFF" cx="12.1" cy="12" rx="9.2" ry="9.2" transform={checked ? 'matrix(1 0 0 1 17.8 0)' : undefined} />
    </svg>
  );
}

export default ToggleIcon;



// WEBPACK FOOTER //
// ./src/components/icons/ToggleIcon.js